<div class="ec-dialog">
  <button type="button" class="ec-close" (click)="close()" aria-label="Close">
    <span class="material-symbols-outlined">close</span>
  </button>

  <div class="ec-icon">
    <span class="material-symbols-outlined">person_search</span>
  </div>

  <h3 class="ec-title">We found existing information with this email</h3>
  <p class="ec-subtitle">
    We found information in our records that may match the email address you used.
    Would you like to use that information or start fresh?
  </p>

  <div class="ec-options">
    <!-- Use Existing -->
    <div class="ec-option">
      <div class="ec-option-head ec-green">
        <span class="material-symbols-outlined">how_to_reg</span>
        Use Existing Information
      </div>
      <ul class="ec-list">
        <li><span class="material-symbols-outlined">check</span> We'll auto-fill the information we have</li>
        <li><span class="material-symbols-outlined">check</span> You can review and edit all details</li>
        <li><span class="material-symbols-outlined">check</span> Faster and easier</li>
      </ul>
    </div>

    <!-- Add Again -->
    <div class="ec-option">
      <div class="ec-option-head ec-blue">
        <span class="material-symbols-outlined">note_add</span>
        Add Again (Fresh Start)
      </div>
      <ul class="ec-list">
        <li><span class="material-symbols-outlined">check</span> Start with a blank form</li>
        <li><span class="material-symbols-outlined">check</span> Add all your information again</li>
        <li><span class="material-symbols-outlined">check</span> Previous information won't be used</li>
      </ul>
    </div>
  </div>

  <div class="ec-actions">
    <button mat-stroked-button color="primary" class="ec-btn-outline" (click)="useExisting()">Use Existing Information</button>
    <button mat-flat-button color="primary" class="ec-btn-solid" (click)="addAgain()">Add Again (Fresh Start)</button>
  </div>

  <div class="ec-footnote">
    <span class="material-symbols-outlined">lock</span>
    Your information is safe and used only for this request in accordance with our
    <a class="ec-link" (click)="openPrivacyPolicy()">Privacy Policy</a>.
  </div>
</div>
